class ModelIndex extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.els.item.elements.forEach((itemEl) => {
      // eslint-disable-next-line compat/compat
      this.observer = new IntersectionObserver(this.onEntry.bind(itemEl), {
        rootMargin: '100px 0px -200px 0px',
        threshold: 1,
      })

      this.observer.observe(itemEl)
    })
  }

  onEntry ([entry], observer) {
    this.classList.toggle(`sec-Index_Item-active`, entry.isIntersecting)
  }
}

if (!customElements.get('model-index')) {
  customElements.define('model-index', ModelIndex)
}
